import { ServiceOffering } from '../../api/services.types';
import { ServerResponse } from '../types';

export interface ConciergeState {
  agencies?: SearchAgency[];
  isFetching: boolean;
}

export interface SearchAgency {
  id: string;
  name: string;
  createdAt: number;
  logoUrl?: string;
  flags: string[];
}

export interface ConciergeAgenciesResponse extends ServerResponse {
  data: SearchAgency[];
}

export interface AgencyResponse {
  data: AgencyData;
}

export interface AgencyAddressesResponse extends ServerResponse {
  data: AgencyAddress[];
}

export interface AgencyAddress {
  id: string;
  streetAddress: string;
  zipcode: string;
  city: string;
  country: string;
  addressType: string;
  establishment: string;
  instructions: string;
  latitude: number;
  longitude: number;
}

export interface AgencyPaymentsResponse extends ServerResponse {
  data: AgencyPayment[];
}

export interface AgencyPayment {
  id: string;
  cardType: string;
  cardLast: string;
  cardExpiryMonth: string;
  cardExpiryYear: string;
  paymentType: string;
  favorite: boolean;
  userAccountId: string;
}

export interface ConciergeAgentsResponse extends ServerResponse {
  data: ConciergeAgent[];
}

export interface ConciergeAgent {
  id: string;
  username: string;
  status: string;
  phoneNumber: string;
  signupZipcode: string;
  buildFullName: string;
  firstName: string;
  lastName: string;
  userAccountType: string;
}

export interface AgencyData extends AgencyMetadata {
  id: string;
}

export interface AgencyMetadata {
  name: string;
  paymentTerms: string;
  defaultPermissionsCreatingAccount: string[];
  defaultPermissionsCreatingPatient: string[];
  defaultPermissionsCreatingPayment: string[];
  defaultPermissionsCreatingAddress: string[];
  logoUrl?: string;
  flags: string[];
  serviceConfigMap: ServiceConfigMap;
}

export type ServiceConfigMap = Record<string, ConciergeAgencyServiceConfig>;

export interface ConciergeAgencyServiceConfig {
  basePrice?: number;
  isBlocked: boolean;
}

export interface AgencyIdentity {
  id: string;
  name: string;
  logoUrl?: string;
}

export interface AgencyService extends ServiceOffering {
  isBlocked: boolean;
  basePrice?: number;
}

export const RESOURCE_PERMISSION_TYPES = ['ALL', 'READ', 'CREATE', 'CHANGE', 'BOOK', 'DESTROY'];
